const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Ansh Shukla</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate PR Head, UPES-CSI</li>
    <li>
        Committed to enhancing CSI's public image.
    </li>
    <li>
        Coordinating outreach and communication strategies.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
